import {
  subscribe,
  broadcast,
  TEventSubscribeHandler,
  TEventUnsubscribeHandler,
} from '@gem/modules/eventBus';

const authSuccessEvent = 'authSuccess';
export function subscribeAuthSuccess(callback: TEventSubscribeHandler): TEventUnsubscribeHandler {
  return subscribe(authSuccessEvent, callback);
}

export function broadcastAuthSuccess(userId: string): void {
  broadcast(authSuccessEvent, userId);
}
